import React__default from 'react';
import { Body, Caption } from '../Typography/index.es.js';
import { DeleteCircleFilled, hasColoredIcon } from '@teko/ds-icon';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_HEIGHT = {
  m: 24,
  l: 32
};
const Wrapper = styled.span`
  ${CommonStyles}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s12};
  padding-right: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.theme.colors.white};
  height: ${(p) => MAPPING_HEIGHT[p.size]}px;
  border-radius: 1.5rem;
  border: ${(p) => p.theme.borderWeight.m} solid
    ${(p) => p.theme.colors.disable};
  ${(p) => p.disabled ? "cursor: not-allowed;" : `
  `}
`;
const Chip = (_a) => {
  var _b = _a, {
    content,
    size = "m",
    closable,
    closeIcon,
    disabled = false,
    onClose = () => {
    },
    onClick
  } = _b, props = __objRest(_b, [
    "content",
    "size",
    "closable",
    "closeIcon",
    "disabled",
    "onClose",
    "onClick"
  ]);
  const getColorCloseIcon = () => {
    var _a2;
    if (!closable || closeIcon || hasColoredIcon(closeIcon))
      return void 0;
    if (disabled)
      return "disabled";
    if (!((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.color))
      return "placeholder";
    return closeIcon.props.color;
  };
  const renderClose = () => {
    var _a2, _b2;
    if (!closable)
      return null;
    return closeIcon ? React__default.cloneElement(closeIcon, {
      size: !((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.size) ? 16 : closeIcon.props.size,
      color: getColorCloseIcon(),
      onClick: (e) => !disabled && onClose(e),
      style: __spreadProps(__spreadValues({}, (_b2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _b2.style), {
        cursor: disabled ? "not-allowed" : "pointer"
      })
    }) : /* @__PURE__ */ React__default.createElement(DeleteCircleFilled, {
      color: disabled ? "disable" : "placeholder",
      size: 16,
      style: { cursor: disabled ? "not-allowed" : "pointer" },
      onClick: (e) => !disabled && onClose(e)
    });
  };
  return /* @__PURE__ */ React__default.createElement(Wrapper, __spreadValues({
    onClick: () => {
      !disabled && onClick && onClick();
    },
    size,
    disabled
  }, props), size === "l" ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Body, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s8" : void 0
  }, content), renderClose()) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Caption, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s4" : void 0
  }, content), renderClose()));
};

export { Chip };
